import { render } from "./VisionHome.vue?vue&type=template&id=1db05aa9&scoped=true"
import script from "./VisionHome.vue?vue&type=script&lang=js"
export * from "./VisionHome.vue?vue&type=script&lang=js"

import "./VisionHome.vue?vue&type=style&index=0&id=1db05aa9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db05aa9"]])

export default __exports__